interface StatTileProps {
  label: string;
  value: string | number;
  trend?: { direction: 'up' | 'down' | 'flat'; pct?: number };
  accent?: 'blue' | 'orange' | 'green' | 'slate';
}

const ACCENTS = {
  blue: 'from-blue-50 to-white border-blue-100',
  orange: 'from-orange-50 to-white border-orange-100',
  green: 'from-emerald-50 to-white border-emerald-100',
  slate: 'from-slate-50 to-white border-slate-200',
};

export function StatTile({ label, value, trend, accent = 'slate' }: StatTileProps) {
  return (
    <div
      className={`rounded-xl border bg-gradient-to-br ${ACCENTS[accent]} p-5 transition hover:shadow-sm`}
    >
      <div className="text-sm font-medium text-slate-600 uppercase tracking-wide">{label}</div>
      <div className="mt-2 flex items-baseline gap-2">
        <div className="text-3xl font-bold text-slate-900">{value}</div>
        {trend && (
          <div
            className={`text-sm font-medium ${
              trend.direction === 'up'
                ? 'text-emerald-600'
                : trend.direction === 'down'
                  ? 'text-red-600'
                  : 'text-slate-500'
            }`}
          >
            {trend.direction === 'up' ? '↑' : trend.direction === 'down' ? '↓' : '→'}
            {trend.pct !== undefined && ` ${trend.pct}%`}
          </div>
        )}
      </div>
    </div>
  );
}
